import { useBankStore } from "@/stores/banks";
import { Button, Input, PickerView, Popup, Toast } from "antd-mobile";
import {
  PickerColumnItem,
  PickerValue,
} from "antd-mobile/es/components/picker-view";
import classNames from "classnames";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./styles.module.scss";
export type BankPickerValue = PickerColumnItem;
interface BankPickerProps {
  visible: boolean; // picker是否显示
  className?: string;
  onClose: () => void; // picker内部点击关闭或遮罩时
  onConfirm?: (val: BankPickerValue[]) => void;
}

const BankPicker: React.FC<BankPickerProps> = (props) => {
  const { visible, className, onClose, onConfirm } = props;
  const [bankList, setBankList] = useState<PickerColumnItem[]>([]);
  const [keyword, setKeyword] = useState<string>("");
  const [banks] = useBankStore((state) => [state.banks]);
  // 变化的值（change）
  const [value, setValue] = useState<PickerValue[]>([]);
  // 确定的值（confirm 点击确定按钮后记录）
  const determinantVal = useRef<PickerValue[]>([]);

  const classes = classNames("bank-picker-popup", className);

  const filterList = useMemo(() => {
    const list = bankList.filter((bank) => `${bank.label}`.includes(keyword));
    if (list.length) {
      return list;
    } else {
      return bankList;
    }
  }, [bankList, keyword]);

  // 点击确定按钮
  const handleConfirm = () => {
    determinantVal.current = [...value];
    if (!value[0]) {
      return Toast.show({
        content: "请选择银行",
      });
    }
    const bank = bankList.find((item) => item.value === value[0]);
    const _value: BankPickerValue[] = bank ? [bank] : [];
    onClose();
    onConfirm && onConfirm(_value);
  };

  // 滑动选择时，根据省筛选市 根据市筛选区县
  const handleChange = (val: PickerValue[]) => {
    setValue(val);
  };

  // mounted时设置省列表
  useEffect(() => {
    setBankList(
      banks.map((item) => ({
        key: item.bankId,
        label: item.bankName,
        value: item.bankId,
      }))
    );
  }, []);

  // 当弹框显示时设置上次点确定时的值和列表
  useEffect(() => {
    if (visible) {
      setValue(determinantVal.current);
    }
  }, [visible]);
  return (
    <Popup className={classes} visible={visible} onMaskClick={onClose}>
      <div className={styles.search}>
        <Input
          placeholder="请输入银行名称进行搜索"
          value={keyword}
          onChange={setKeyword}
        />
      </div>
      <div className={classNames(styles.actions, "popup-hd fx fx-hb fx-vc")}>
        <Button
          fill="none"
          onClick={onClose}
          className={classNames(styles.action)}
        >
          取消
        </Button>
        <Button
          color="primary"
          fill="none"
          onClick={() => {handleConfirm()}}
          className={classNames(styles.action, styles.action_submit)}
        >
          确定
        </Button>
      </div>

      <div className="popup-bd">
        <PickerView
          // columns={[ provinceList, cityList, countyList ]}
          columns={[filterList]}
          value={value}
          onChange={(val) => handleChange(val)}
        />
      </div>
    </Popup>
  );
};

export default BankPicker;
